import { render } from "./CardModelForm.vue?vue&type=template&id=0e7c545c"
import script from "./CardModelForm.vue?vue&type=script&lang=js"
export * from "./CardModelForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__